module.exports = __webpack_public_path__ + "media/images/dollar-84fc89ce4036fbfa5590e139d7e484e6.png";